export const _setReportExecution = (state, action) => action.payload;
